import { Checkbox, Col } from 'antd';
import styled from 'styled-components';
import { DEFAULT_RISK_RPN_COLOR } from '@/utils/constants';

interface CardScoreProps {
	$isSelected: boolean;
	$position?: 'right' | 'left';
}

export const CardScore = styled(Col)<CardScoreProps>`
	position: absolute;
	top: 8px;
	right: 8px;
	right: ${({ $position }) => ($position === 'left' ? 'auto' : '8px')};
	left: ${({ $position }) => ($position === 'left' ? '8px' : 'auto')};
	span {
		color: #ffffff;
		font-size: 1rem;
		border-radius: 6px;
		padding: ${({ $position }) => ($position === 'left' ? '2px 4px' : '2px 10px')};
		background-color: ${({ $isSelected }) => ($isSelected ? DEFAULT_RISK_RPN_COLOR : '#b3b3b3')};
	}
`;

export const CustomCheckbox = styled(Checkbox)<CardScoreProps>`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	text-align: center !important;
	padding: 10%;
	min-height: 160px;
	border-radius: 18px !important;
	color: #262626 !important;
	border: 2px solid ${({ $isSelected }) => ($isSelected ? DEFAULT_RISK_RPN_COLOR : '#d9d9d9')};
	background-color: ${({ $isSelected }) => ($isSelected ? '#eaeefd' : '#ffffff')};
	span {
		width: 100%;
	}
	.ant-typography {
	}
	.ant-checkbox {
		display: none;
	}
`;
